import React from "react";
import Layout from "src/components/Layout";
import "./OccupationalHealth.css";
import image from "../../images/4.png";
import InfoCard from "src/components/InfoCard";

const occupationalhealth: React.FC = () => {
  return (
    <Layout>
      <InfoCard title={"occupational health"} image={image}>
        <div className="occupational-details">
          <p>
            Our occupational doctors help individuals with illness and/or injury
            resume work duties on a gradual basis through transitional work.
            Transitional work uses the actual work tasks and environments as a
            form of rehabilitation. Also, we provide the following assessments
          </p>
          <p>
            <strong></strong>• Pre-Employment Medical Fitness Assessment.
            <br></br>• Annual Medical Fitness Assessment.<br></br>• Marine
            (Seafarer Medical) Fitness Assessment.<br></br>• Health Risk
            Assessment.<br></br>• Workplace Injury Assessment.<br></br>• Drug &
            Alcohol Testing.<br></br>• Chester Step Test.
          </p>
        </div>
      </InfoCard>
    </Layout>
  );
};

export default occupationalhealth;
